/* ================================================================
   NewJaisa Enterprise — B2B Resource Playbook
   File    : assets/b2b-resource-playbook.js
   Scope   : All IDs prefixed with b2b-, all functions b2b-namespaced
             Zero conflicts with global Shopify / theme JS
   ================================================================ */

/* ── Deck data ─────────────────────────────────────────────────── */
const B2B_DECKS = [
  {
    id: 1, ind: 'bfsi', label: 'BFSI', emoji: '🏦',
    title: 'BFSI IT Procurement Playbook',
    subtitle: 'Compliance-first device strategy for banks, NBFCs, and insurance companies operating across India.',
    pages: '14 slides',
    desc: 'RBI-aligned. Secure. Audit-ready.',
    items: [
      { icon: '🔐', t: 'RBI & Compliance Checklist',  b: 'Device requirements under RBI IT framework, SEBI & IRDAI guidelines for financial institutions.' },
      { icon: '💰', t: 'CapEx vs OpEx Modelling',     b: '70% cost reduction framework with lease vs buy analysis and full TCO breakdown for BFSI ops.' },
      { icon: '🏢', t: 'Branch Rollout Playbook',     b: 'Proven deployment model for 50–500 branch networks with zero-downtime cut-overs.' },
      { icon: '🛡️', t: 'Data Security Protocols',     b: 'Certified data wipe, BIOS lock, and device traceability for audit documentation.' },
    ],
    dynLabel: 'Number of Branches',
    dynOpts: ['1–10', '11–50', '51–200', '201–500', '500+'],
  },
  {
    id: 2, ind: 'bpo', label: 'BPO & Call Centers', emoji: '📞',
    title: 'BPO Agent Seat Deployment Playbook',
    subtitle: 'High-velocity deployment frameworks for BPO operations scaling from 50 to 5,000+ agent seats.',
    pages: '13 slides',
    desc: 'Speed, scale, and cost — all three.',
    items: [
      { icon: '⚡', t: '500 Seats in 5 Days',         b: 'Logistics & staging framework for rapid bulk deployment across single or multi-city BPO ops.' },
      { icon: '📊', t: 'Cost Per Seat Modelling',     b: 'Benchmark data from 1,200+ seat deployments — actual savings vs new hardware procurement.' },
      { icon: '🔄', t: 'Refresh & Rotation Strategy', b: 'Rolling refresh model to keep agent productivity high without capital spikes.' },
      { icon: '🌐', t: 'Pan-India Logistics Guide',   b: 'City-wise deployment coordination with tracking, inventory manifests, and SLA commitments.' },
    ],
    dynLabel: 'Current Agent Seat Count',
    dynOpts: ['< 50', '50–200', '201–500', '501–2000', '2000+'],
  },
  {
    id: 3, ind: 'it', label: 'IT & Tech', emoji: '💻',
    title: 'IT & Tech Company Device Playbook',
    subtitle: 'Dev workstation standards, remote work infrastructure, and fleet management for tech teams.',
    pages: '13 slides',
    desc: 'Specs devs actually want.',
    items: [
      { icon: '🖥️', t: 'Dev Workstation Specs',       b: 'Recommended configs for frontend, backend, data science, and DevOps roles — all refurbished.' },
      { icon: '🏠', t: 'Remote Work Kit Guide',        b: 'Standardised remote employee hardware bundles with delivery SLAs across India.' },
      { icon: '📋', t: 'Asset Management Playbook',   b: 'ITAM workflows, tagging systems, and lifecycle tracking for 200–5000 device fleets.' },
      { icon: '🔧', t: 'SLA & Support Structure',     b: 'Uptime SLAs, advance replacement protocols and escalation paths for tech companies.' },
    ],
    dynLabel: 'Engineering Team Size',
    dynOpts: ['1–20', '21–100', '101–500', '500+'],
  },
  {
    id: 4, ind: 'edtech', label: 'EdTech & Education', emoji: '🎓',
    title: 'EdTech & Education Device Playbook',
    subtitle: 'Scalable device programmes for ed-platforms, schools, colleges and training institutes.',
    pages: '12 slides',
    desc: 'Learning-ready. Budget-friendly.',
    items: [
      { icon: '🎓', t: 'Computer Lab Build Guide',     b: 'Per-seat cost models for building 30–500 seat computer labs with uniform hardware specs.' },
      { icon: '👨‍💻', t: 'Student Device Bundles',       b: 'Curated device packages for student onboarding with education-grade QC standards.' },
      { icon: '📈', t: 'EdTech Scale Playbook',        b: 'IT procurement strategy for ed-platforms growing from 5 to 500 employees.' },
      { icon: '♻️', t: 'Device Lifecycle for Education', b: 'Annual refresh cycles, donate-after-use CSR integration, and e-waste compliance.' },
    ],
    dynLabel: 'Institution Type',
    dynOpts: ['School / K-12', 'College / University', 'EdTech Platform', 'Coaching / Training', 'Government Institution'],
  },
  {
    id: 5, ind: 'fintech', label: 'Fintech', emoji: '💳',
    title: 'Fintech Startup IT Playbook',
    subtitle: 'Cost-effective, compliance-ready device strategy for payments, lending, and wealth-tech companies.',
    pages: '12 slides',
    desc: 'Regulated and ready to scale.',
    items: [
      { icon: '🚀', t: 'Seed to Series B Device Plan',  b: 'Stage-by-stage IT procurement roadmap as your fintech scales from 10 to 500+ employees.' },
      { icon: '🔐', t: 'PCI-DSS Device Compliance',    b: 'Hardware requirements and data security checklist for payment processing environments.' },
      { icon: '📊', t: 'OpEx IT Model for Fintechs',   b: 'Lease and rental structures preserving runway while meeting investor IT expectations.' },
      { icon: '🌆', t: 'Remote-First Infra Guide',     b: 'Distributed team device management for fintechs with hybrid or fully remote models.' },
    ],
    dynLabel: 'Funding Stage',
    dynOpts: ['Bootstrapped', 'Pre-Seed / Angel', 'Seed', 'Series A', 'Series B+'],
  },
  {
    id: 6, ind: 'healthcare', label: 'Healthcare & Pharma', emoji: '🏥',
    title: 'Healthcare & Pharma IT Playbook',
    subtitle: 'HIPAA-aware, clinically compliant device deployment for hospitals, clinics, and diagnostic labs.',
    pages: '14 slides',
    desc: 'Patient-safe. Audit-proof.',
    items: [
      { icon: '🏥', t: 'Clinical Workstation Standards', b: 'Recommended hardware specs for EMR systems, diagnostic software and nurse stations.' },
      { icon: '🔒', t: 'HIPAA & Data Compliance',       b: 'Device configuration, encryption, and access control checklists for healthcare environments.' },
      { icon: '⚡', t: 'Zero-Downtime Deployment',      b: 'Staging and rollout methodology ensuring clinical operations continue uninterrupted.' },
      { icon: '🧪', t: 'Lab & Pharma Device Guide',     b: 'Device specs for lab environments, pharma R&D workstations and cold-chain monitoring.' },
    ],
    dynLabel: 'Organisation Type',
    dynOpts: ['Hospital / Multi-Speciality', 'Diagnostic Lab', 'Clinic / Polyclinic', 'Pharma Company', 'Health-tech Startup'],
  },
  {
    id: 7, ind: 'startup', label: 'Startups & SMBs', emoji: '🚀',
    title: 'Startup & SMB Growth Playbook',
    subtitle: 'Zero-waste IT setup for seed to Series B startups — fast, lean, and investor-friendly.',
    pages: '13 slides',
    desc: 'Move fast. Spend smart.',
    items: [
      { icon: '💡', t: 'Day-1 IT Setup Guide',         b: 'Minimum viable IT stack for 10–50 person startups — what to buy, what to defer.' },
      { icon: '📈', t: 'Scale-Up Device Strategy',     b: 'Procurement triggers, bulk pricing thresholds and account management from 50–500 seats.' },
      { icon: '💰', t: 'Runway-Preserving IT Model',   b: 'OpEx IT frameworks that preserve VC capital while meeting board IT expectations.' },
      { icon: '🌏', t: 'Remote Hiring Kit',            b: 'Pan-India employee onboarding hardware kits shipped in under 72 hours, anywhere.' },
    ],
    dynLabel: 'Funding Stage',
    dynOpts: ['Bootstrapped', 'Pre-Seed', 'Seed', 'Series A', 'Series B', 'Series B+'],
  },
  {
    id: 8, ind: 'manufacturing', label: 'Manufacturing', emoji: '🏭',
    title: 'Manufacturing & Industrial IT Playbook',
    subtitle: 'Shop floor computing, ERP workstations and asset lifecycle management for manufacturing plants.',
    pages: '13 slides',
    desc: 'Built for the floor and the office.',
    items: [
      { icon: '🏭', t: 'Shop Floor Device Guide',      b: 'Rugged computing specs for factory environments — dust, heat and vibration tolerant.' },
      { icon: '⚙️', t: 'ERP & CAD Workstation Specs', b: 'Hardware benchmarks for SAP, Oracle, AutoCAD and manufacturing ERP workloads.' },
      { icon: '🔄', t: 'Asset Lifecycle Management',  b: 'Full lifecycle framework from procurement to certified disposal — EPR and CPCB compliant.' },
      { icon: '📦', t: 'Multi-Plant Deployment Plan', b: 'Coordinated device rollout across multiple plant locations with zero production disruption.' },
    ],
    dynLabel: 'Number of Plants / Locations',
    dynOpts: ['1', '2–5', '6–20', '20+'],
  },
    {
    /* ── ID 9 — unique, not a copy of Fintech ── */
    id: 9, ind: 'retail', label: 'Retail & D2C', emoji: '🛍️',
    title: 'Retail & D2C IT Playbook',
    subtitle: 'Store-to-warehouse device strategy for retail chains, D2C brands, and omnichannel commerce businesses.',
    pages: '13 slides',
    desc: 'In-store ready. Omnichannel enabled.',
    items: [
      { icon: '🏪', t: 'Store Infrastructure Guide',    b: 'POS terminal specs, billing workstations, and cashier device standards for retail outlets.' },
      { icon: '📦', t: 'Warehouse & Inventory Devices', b: 'Barcode scanners, ruggedised tablets, and inventory management hardware for warehouses.' },
      { icon: '🔄', t: 'Seasonal Refresh Strategy',     b: 'Scale device fleet up or down around peak seasons — Diwali, year-end sales — without capital lock-in.' },
      { icon: '🌐', t: 'Omnichannel IT Framework',      b: 'Unified device management across physical stores, dark stores, and D2C fulfilment centres.' },
    ],
    dynLabel: 'Number of Stores / Outlets',
    dynOpts: ['1–5', '6–20', '21–50', '51–200', '200+'],
  },
];

/* ── State ─────────────────────────────────────────────────────── */
let b2bCurrentDeck = null;

/* ── Helpers ───────────────────────────────────────────────────── */
function b2bEl(id) { return document.getElementById(id); }

/* ── Screen switcher ───────────────────────────────────────────── */
function b2bShowScreen(id) {
  document.querySelectorAll('.b2b-page .b2b-screen').forEach(function(s) {
    s.classList.remove('b2b-screen--active');
    s.setAttribute('aria-hidden', 'true');
  });
  const target = b2bEl(id);
  if (target) {
    target.classList.add('b2b-screen--active');
    target.removeAttribute('aria-hidden');
  }
}

/* ── Render deck grid ──────────────────────────────────────────── */
function b2bRenderDecks(filter) {
  const grid = b2bEl('b2b-decks-grid');
  if (!grid) return;

  const list = filter === 'all'
    ? B2B_DECKS
    : B2B_DECKS.filter(function(d) { return d.ind === filter; });

  grid.innerHTML = list.map(function(d) {
    return (
      '<div class="b2b-deck-card" role="listitem" tabindex="0"' +
      '  onclick="b2bOpenPlaybook(' + d.id + ')"' +
      '  onkeydown="if(event.key===\'Enter\'||event.key===\' \')b2bOpenPlaybook(' + d.id + ')"' +
      '  aria-label="Open ' + d.title + '">' +
      '  <div class="b2b-deck-card__thumb b2b-thumb--' + d.ind + '">' + d.emoji + '</div>' +
      '  <div class="b2b-deck-card__body">' +
      '    <div class="b2b-deck-card__ind">'   + d.label + '</div>' +
      '    <div class="b2b-deck-card__title">' + d.title + '</div>' +
      '    <div class="b2b-deck-card__desc">'  + d.desc  + '</div>' +
      '  </div>' +
      '  <div class="b2b-deck-card__foot">' +
      '    <span class="b2b-deck-card__pages">📄 ' + d.pages + '</span>' +
      '    <button class="b2b-dl-btn" tabindex="-1" aria-hidden="true">⬇ Download Deck</button>' +
      '  </div>' +
      '</div>'
    );
  }).join('');
}

/* ── Filter tabs ───────────────────────────────────────────────── */
function b2bFilterDecks(industry, btn) {
  document.querySelectorAll('.b2b-page .b2b-tab').forEach(function(t) {
    t.classList.remove('b2b-tab--active');
    t.setAttribute('aria-selected', 'false');
  });
  btn.classList.add('b2b-tab--active');
  btn.setAttribute('aria-selected', 'true');
  b2bRenderDecks(industry);
}

/* ── Open playbook detail ──────────────────────────────────────── */
function b2bOpenPlaybook(id) {
  b2bCurrentDeck = B2B_DECKS.find(function(d) { return d.id === id; });
  if (!b2bCurrentDeck) return;

  const d = b2bCurrentDeck;

  /* Hero fields */
  b2bEl('b2b-pb-badge-icon').textContent  = d.emoji;
  b2bEl('b2b-pb-badge-label').textContent = d.label;
  b2bEl('b2b-pb-title').textContent       = d.title;
  b2bEl('b2b-pb-subtitle').textContent    = d.subtitle;
  b2bEl('b2b-pb-pages').textContent       = d.pages;
  b2bEl('b2b-pb-hero-emoji').textContent  = d.emoji;
  b2bEl('b2b-crumb-name').textContent     = d.label;

  /* Content list */
  b2bEl('b2b-pb-list').innerHTML = d.items.map(function(c) {
    return (
      '<div class="b2b-pb-item" role="listitem">' +
      '  <div class="b2b-pb-item-icon">' + c.icon + '</div>' +
      '  <div>' +
      '    <div class="b2b-pb-item-title">' + c.t + '</div>' +
      '    <div class="b2b-pb-item-body">'  + c.b + '</div>' +
      '  </div>' +
      '</div>'
    );
  }).join('');

  /* Dynamic industry field */
  const dynWrap = b2bEl('b2b-dyn-wrap');
  if (d.dynLabel) {
    b2bEl('b2b-dyn-label').textContent = d.dynLabel + ' *';
    b2bEl('b2b-dyn-select').innerHTML =
      '<option value="">Select</option>' +
      d.dynOpts.map(function(o) { return '<option>' + o + '</option>'; }).join('');
    dynWrap.style.display = 'flex';
    dynWrap.removeAttribute('aria-hidden');
  } else {
    dynWrap.style.display = 'none';
    dynWrap.setAttribute('aria-hidden', 'true');
  }

  /* Explore-more grid (other industries, max 6) */
  const others = B2B_DECKS.filter(function(x) { return x.ind !== d.ind; }).slice(0, 6);
  b2bEl('b2b-explore-grid').innerHTML = others.map(function(x) {
    return (
      '<div class="b2b-exp-card" role="listitem" tabindex="0"' +
      '  onclick="b2bOpenPlaybook(' + x.id + ')"' +
      '  onkeydown="if(event.key===\'Enter\'||event.key===\' \')b2bOpenPlaybook(' + x.id + ')"' +
      '  aria-label="Open ' + x.title + '">' +
      '  <div class="b2b-exp-icon">' + x.emoji + '</div>' +
      '  <div>' +
      '    <div class="b2b-exp-title">' + x.title + '</div>' +
      '    <div class="b2b-exp-desc">'  + x.label + ' · ' + x.pages + '</div>' +
      '    <div class="b2b-exp-cta">Get this deck →</div>' +
      '  </div>' +
      '</div>'
    );
  }).join('');

  /* Clear form fields */
  ['b2b-f-first', 'b2b-f-last', 'b2b-f-mobile', 'b2b-f-email', 'b2b-f-company'].forEach(function(fid) {
    var el = b2bEl(fid);
    if (el) el.value = '';
  });
  ['b2b-f-jobtitle', 'b2b-dyn-select'].forEach(function(fid) {
    var el = b2bEl(fid);
    if (el) el.selectedIndex = 0;
  });

  b2bShowScreen('b2b-screen-playbook');
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

/* ── Form submit ───────────────────────────────────────────────── */
// function b2bSubmitForm() {
//   const first   = (b2bEl('b2b-f-first').value || '').trim();
//   const last    = (b2bEl('b2b-f-last').value || '').trim();
//   const mobile = (b2bEl('b2b-f-mobile').value || '').replace(/\D/g, '').slice(-10);
//   const email   = (b2bEl('b2b-f-email').value || '').trim();
//   const company = (b2bEl('b2b-f-company').value || '').trim();
//   const role    = (b2bEl('b2b-f-jobtitle').value || '');
//   const branches = (b2bEl('b2b-dyn-select').value || '');

//   // ✅ VALIDATION
//   if (!first || !mobile || !email || !company) {
//     alert('Please fill all required fields');
//     return;
//   }
//   // ✅ MOBILE VALIDATION
// if (!/^[6-9][0-9]{9}$/.test(mobile)) {
//   alert("Please enter valid 10 digit mobile number");
//   return;
// }

//   if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
//     alert('Invalid email');
//     return;
//   }

//   // ✅ UTM CAPTURE
//   let utm = localStorage.getItem("utm_params") || window.location.search || "Direct";

//   // ✅ Apps Script URL (PLAYBOOK SHEET)
//   const scriptURL = "https://script.google.com/macros/s/AKfycbyBh6fIy2G0BwKQPM8gi6Xln4lCT3z4zVNvpd6_a0fX0Lavyaq1k5A1nX_lwgt2ehYx/exec";

// const formData = new FormData();

// formData.append("first_name", first);   // ✅ ADD THIS
// formData.append("last_name", last);
// formData.append("mobile", mobile);
// formData.append("email", email);
// formData.append("company", company);
// formData.append("role", role);
// formData.append("branches", branches);
// formData.append("utm", utm);

//   // ✅ SEND DATA
//   fetch(scriptURL, {
//     method: "POST",
//     body: formData
//   })
//   .then(res => res.text())
//   .then(() => {

//     // SUCCESS UI
//     b2bEl('b2b-s-deck').textContent = b2bCurrentDeck?.title || '';
//     b2bEl('b2b-s-email').textContent = email;

//     b2bShowScreen('b2b-screen-success');

//   })
//   .catch(() => {
//     alert("Something went wrong");
//   });
// }


function b2bSubmitForm() {

  const first   = (b2bEl('b2b-f-first').value || '').trim();
  const last    = (b2bEl('b2b-f-last').value || '').trim();

  // ✅ CLEAN MOBILE (ONLY LAST 10 DIGITS)
  const mobile  = (b2bEl('b2b-f-mobile').value || '').replace(/\D/g, '').slice(-10);

  const email   = (b2bEl('b2b-f-email').value || '').trim();
  const company = (b2bEl('b2b-f-company').value || '').trim();
  const role    = (b2bEl('b2b-f-jobtitle').value || '');
  const branches = (b2bEl('b2b-dyn-select').value || '');

  // ✅ REQUIRED VALIDATION
  if (!first || !mobile || !email || !company) {
    alert('Please fill all required fields');
    return;
  }

  // ✅ MOBILE VALIDATION (INDIA)
  if (!/^[6-9][0-9]{9}$/.test(mobile)) {
    alert("Please enter valid 10 digit mobile number");
    return;
  }

  // ✅ EMAIL VALIDATION
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    alert('Invalid email');
    return;
  }

  // ✅ UTM CAPTURE
  let utm = localStorage.getItem("utm_params") || window.location.search || "Direct";

  // ✅ NEW IMPORTANT DATA (AUTO FROM SELECTED CARD)
  const industry = b2bCurrentDeck ? b2bCurrentDeck.label : "";
  const playbook = b2bCurrentDeck ? b2bCurrentDeck.title : "";

  // ✅ Apps Script URL
  const scriptURL = "https://script.google.com/macros/s/AKfycbzkVSTZmJWYHCDcHrPX3PUtd324WpqI96n8KpyPa8rOhiWOWlHE_HcbIUkZSsLS6DaH/exec";

  const formData = new FormData();

  formData.append("first_name", first);
  formData.append("last_name", last);
  formData.append("mobile", mobile);
  formData.append("email", email);
  formData.append("company", company);
  formData.append("role", role);
  formData.append("branches", branches);
  formData.append("utm", utm);

  // ✅ NEW FIELDS (CRITICAL)
  formData.append("industry", industry);
  formData.append("playbook", playbook);

  // ✅ SEND DATA
  fetch(scriptURL, {
    method: "POST",
    body: formData
  })
  .then(res => res.text())
  .then(() => {

    // ✅ SUCCESS UI
    b2bEl('b2b-s-deck').textContent = playbook;
    b2bEl('b2b-s-email').textContent = email;

    b2bShowScreen('b2b-screen-success');

  })
  .catch(() => {
    alert("Something went wrong");
  });
}

/* ── Navigation ────────────────────────────────────────────────── */
function b2bGoBack() {
  b2bShowScreen('b2b-screen-resources');
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

/* ── Init ──────────────────────────────────────────────────────── */
(function b2bInit() {
  b2bRenderDecks('all');
})();
